import { LOAD_CLINICS, SELECT_CLINIC } from "./actions";
import * as R from "ramda";
import _ from "lodash";

const initialState = { isLoading: false, selectedClinic: {} };

const clinics = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CLINICS.REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_CLINICS.SUCCESS: {
      // eslint-disable-next-line no-shadow
      const clinics = R.path(["payload", "response", "entities", "clinics"], action);
      const selectedClinic = _.values(clinics || {})[0];
      return {
        ...state,
        selectedClinic,
        isLoading: false,
      };
    }
    case LOAD_CLINICS.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SELECT_CLINIC:
      return {
        ...state,
        selectedClinic: action.payload.clinic,
      };
    default:
      return state;
  }
};

export default clinics;
